import { Modal } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SucessModal from 'src/components/sucess-modal';
import { paths } from 'src/paths';
import {
  getAssignedFacilities,
  getTherapistProfileAction,
  storeFacilityUuid,
} from 'src/redux/actions/facilityActions';
import loader from 'src/components/LoaderImg/loader.gif';
import AuthContext, { logoutUser } from 'src/routes/AuthContext';

function LandingPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { redirectSupervisor } = paths;
  const auth = useContext(AuthContext);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const profileResponse = useSelector((state: any) => state?.getTherapistProfileReducer);
  const __accessToken = auth.token;

  useEffect(() => {
    if (!__accessToken) return;
    const parsedToken: any = auth.tokenParsed || '';
    localStorage.setItem('realm', auth.realm || '');
    if (auth.tokenParsed?.realm_access?.roles?.includes('physician')) {
      dispatch(getTherapistProfileAction());
      return;
    }
    if (!parsedToken.lastLoggedInFacility) {
      setShowWarningModal(true);
      return;
    }
    localStorage.setItem('facilityId', parsedToken.lastLoggedInFacility);
    dispatch(storeFacilityUuid(parsedToken.lastLoggedInFacility));
    dispatch(getAssignedFacilities());
    dispatch(getTherapistProfileAction());
  }, [__accessToken]);

  useEffect(() => {
    if (profileResponse.response?.code === 'INTERNAL_ERROR') {
      navigate('/server-error');
      return;
    }
    if (profileResponse.response === null && !profileResponse.getAdminProfile) return;
    navigate(redirectSupervisor);
  }, [profileResponse]);

  const redirectToLoginPage = () => {
    logoutUser();
  };

  return (
    <div>
      {profileResponse?.loader && (
        <img
          src={loader}
          alt="loading..."
          style={{ margin: 'auto', display: 'block' }}
        />
      )}
      <Modal open={showWarningModal}>
        <SucessModal
          title="Error"
          message="You are not associated to any facility or Login details are incorrect, please try again"
          close={redirectToLoginPage}
          isSucess={false}
        />
      </Modal>
    </div>
  );
}

export default LandingPage;
